export const useMockApi = (window as any)?.bootstrap?.useMockApi;

const apiEnvironment = (window as any)?.bootstrap?.apiEnvironment;

const dev2: ApiEndpoints = {
	personPrc: 'https://dev2.enterprise-api.cpg.org/person-prc/1.0/client/person',

	organizationPrc: 'https://dev2.enterprise-api.cpg.org/organization-prc/1.0/client/organization',

	miscPrc: 'https://dev2.enterprise-api.cpg.org/common-proxy-api/misc-prc/1.0',

	benAdmin: 'https://dev2.enterprise-api.cpg.org/common-proxy-api/benadmin-prc/1.0',

	mlps: 'https://dev2.enterprise-api.cpg.org/common-proxy-api/ghl-prc/1.0',

	wam: 'https://dev2.enterprise-api.cpg.org/common-proxy-api/wam-prc/1.0/external_api',

	notification: 'https://dev2.enterprise-api.cpg.org/common-proxy-api/notification-prc/1.0/notification',

	myCpgPod: 'https://dev2.enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0',

	reportPrc: 'https://dev2.enterprise-api.cpg.org/common-proxy-api/reports-prc/1.0',

	domoUrl: 'https://domo-dev2.cpg.org/api/card?',

	contentApi: 'https://cpg-tcsm-r3-4-dev.adagetech.net',

	changeLogApi: 'https://dev2.enterprise-api.cpg.org/event-audit-prc/1.0',

	clergyBioApi: 'https://dev2.enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://dev2.enterprise-api.cpg.org/person-prc/1.0/admin/client/person',

	
	cicApi: 'https://dev2.enterprise-api.cpg.org/osscr-client/api',
};

const test1: ApiEndpoints = {
	personPrc: 'https://test1.enterprise-api.cpg.org/person-prc/1.0/client/person',

	organizationPrc: 'https://test1.enterprise-api.cpg.org/organization-prc/1.0/client/organization',

	miscPrc: 'https://test1.enterprise-api.cpg.org/common-proxy-api/misc-prc/1.0',

	benAdmin: 'https://test1.enterprise-api.cpg.org/common-proxy-api/benadmin-prc/1.0',

	mlps: 'https://test1.enterprise-api.cpg.org/common-proxy-api/ghl-prc/1.0',

	wam: 'https://test1.enterprise-api.cpg.org/common-proxy-api/wam-prc/1.0/external_api',

	notification: 'https://test1.enterprise-api.cpg.org/notification-prc/1.0/notification',

	myCpgPod: 'https://test1.enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0',

	reportPrc: 'https://test1.enterprise-api.cpg.org/common-proxy-api/reports-prc/1.0',

	domoUrl: 'https://domo-test.cpg.org/api/card?',

	contentApi: 'https://test.cpg.org',

	changeLogApi: 'https://test1.enterprise-api.cpg.org/event-audit-prc/1.0',

	clergyBioApi: 'https://test1.enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://test1.enterprise-api.cpg.org/person-prc/1.0/admin/client/person',

	cicApi: 'https://test1.enterprise-api.cpg.org/osscr-client/api',

};

const test2: ApiEndpoints = {
	personPrc: 'https://test2.enterprise-api.cpg.org/person-prc/1.0/client/person',

	organizationPrc: 'https://test2.enterprise-api.cpg.org/organization-prc/1.0/client/organization',

	miscPrc: 'https://test2.enterprise-api.cpg.org/common-proxy-api/misc-prc/1.0',

	benAdmin: 'https://test2.enterprise-api.cpg.org/common-proxy-api/benadmin-prc/1.0',

	mlps: 'https://test2.enterprise-api.cpg.org/common-proxy-api/ghl-prc/1.0',

	wam: 'https://test2.enterprise-api.cpg.org/common-proxy-api/wam-prc/1.0/external_api',

	notification: 'https://test2.enterprise-api.cpg.org/notification-prc/1.0/notification',

	myCpgPod: 'https://test2.enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0',

	reportPrc: 'https://test2.enterprise-api.cpg.org/common-proxy-api/reports-prc/1.0',

	domoUrl: 'https://domo-qa.cpg.org/api/card?',

	contentApi: 'https://test.cpg.org',

	changeLogApi: 'https://test2.enterprise-api.cpg.org/event-audit-prc/1.0',

	clergyBioApi: 'https://test2.enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://test2.enterprise-api.cpg.org/person-prc/1.0/admin/client/person',

	cicApi: 'https://test2.enterprise-api.cpg.org/osscr-client/api',

};

const sandbox: ApiEndpoints = {
	personPrc: 'https://sbox.enterprise-api.cpg.org/person-prc/1.0/client/person',

	organizationPrc: 'https://sbox.enterprise-api.cpg.org/organization-prc/1.0/client/organization',

	miscPrc: 'https://sbox.enterprise-api.cpg.org/common-proxy-api/misc-prc/1.0',

	benAdmin: 'https://sbox.enterprise-api.cpg.org/common-proxy-api/benadmin-prc/1.0',

	mlps: 'https://sbox.enterprise-api.cpg.org/common-proxy-api/ghl-prc/1.0',

	wam: 'https://sbox.enterprise-api.cpg.org/common-proxy-api/wam-prc/1.0/external_api',

	notification: 'https://sbox.enterprise-api.cpg.org/notification-prc/1.0/notification',

	myCpgPod: 'https://sbox.enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0',

	reportPrc: 'https://sbox.enterprise-api.cpg.org/common-proxy-api/reports-prc/1.0',

	domoUrl: 'https://domo.cpg.org/api/card?',

	contentApi: 'https://qatest.cpg.org',

	changeLogApi: 'https://sbox.enterprise-api.cpg.org/event-audit-prc/1.0',

	clergyBioApi: 'https://sbox.enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://sbox.enterprise-api.cpg.org/person-prc/1.0/admin/client/person',

	cicApi: 'https://sbox.enterprise-api.cpg.org/osscr-client/api',

};

const prod: ApiEndpoints = {

	personPrc: 'https://enterprise-api.cpg.org/person-prc/1.0/client/person',

	organizationPrc: 'https://enterprise-api.cpg.org/organization-prc/1.0/client/organization',

	miscPrc: 'https://enterprise-api.cpg.org/common-proxy-api/misc-prc/1.0',

	benAdmin: 'https://enterprise-api.cpg.org/common-proxy-api/benadmin-prc/1.0',

	mlps: 'https://enterprise-api.cpg.org/common-proxy-api/ghl-prc/1.0',

	wam: 'https://enterprise-api.cpg.org/common-proxy-api/wam-prc/1.0/external_api',

	notification: 'https://enterprise-api.cpg.org/notification-prc/1.0/notification',

	myCpgPod: 'https://enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0',

	reportPrc: 'https://enterprise-api.cpg.org/common-proxy-api/reports-prc/1.0',

	domoUrl: 'https://domo.cpg.org/api/card?',

	contentApi: 'https://www.cpg.org',

	changeLogApi: 'https://enterprise-api.cpg.org/event-audit-prc/1.0',

	clergyBioApi: 'https://enterprise-api.cpg.org/common-proxy-api/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://enterprise-api.cpg.org/person-prc/1.0/admin/client/person',

	cicApi: 'https://enterprise-api.cpg.org/osscr-client/api',

};


interface ApiEndpoints {
	personPrc: string;
	organizationPrc: string;
	miscPrc: string;
	benAdmin: string;
	mlps: string;
	wam: string;
	notification: string;
	myCpgPod: string;
	reportPrc: string;
	domoUrl: string;
	contentApi: string;
	changeLogApi: string;
	clergyBioApi: string;
	personPrcAdmin?: string;
	cicApi?: string;
}

const ApiEndPoints = {
	dev2,
	test1,
	test2,
	sandbox,
	prod,
};

const defaultApi = 'dev2';

export const ApiEndpoint = ApiEndPoints[apiEnvironment || defaultApi] as ApiEndpoints;